import ReactGA from "react-ga";
import {
  GA_UTM_SOURCE,
  GA_UTM_MEDIUM,
  GA_UTM_CAMPAIGN,
  GA_IP,
  GA_UUID,
  lineOAUrl,
} from "config/const";
import { shopId } from "config/const";

const oaMap = {
  mirror_media: "https://lin.ee/udlSMaC8",
  iww: "https://lin.ee/31hitwj",
  www: "https://lin.ee/nyopoE0",
  watchview: "https://lin.ee/4ldeF0V",
  horoguides: "https://lin.ee/wG3UYcc",
  imagine_mobile: "https://lin.ee/AbYHNAQ",
};

export const getOALink = () => {
  return oaMap[localStorage.getItem(GA_UTM_SOURCE)] || lineOAUrl;
};

export const sendGAEvent = (lineId, ga) => {
  if (!lineId || !ga) return;

  ReactGA.set({
    userId: `shop/${shopId}/user/${lineId}`,
    referrer: `https://linebot/shop/${shopId}/user/${lineId}`,
    title: ga,
  });
  const event = {
    category: `campaign/${shopId}`,
    action: `submit/${localStorage.getItem(GA_UTM_SOURCE)}`,
    label: `shop/${shopId}/customer/${lineId}/campaign/${localStorage.getItem(
      GA_UTM_CAMPAIGN
    )}/source/${localStorage.getItem(
      GA_UTM_MEDIUM
    )}/medium/${localStorage.getItem(
      GA_UTM_CAMPAIGN
    )}/ip/${localStorage.getItem(GA_IP)}`,
    value: 1,
  };
  ReactGA.event(event);
};

export const setGAInLocalstorage = ({
  ga_utm_source,
  ga_utm_medium,
  ga_utm_campaign,
}) => {
  console.log(
    "ga_utm_source:" + ga_utm_source,
    "ga_utm_medium:" + ga_utm_medium,
    "ga_utm_campaign:" + ga_utm_campaign
  );
  localStorage.setItem(GA_UTM_SOURCE, ga_utm_source);
  localStorage.setItem(GA_UTM_MEDIUM, ga_utm_medium);
  localStorage.setItem(GA_UTM_CAMPAIGN, ga_utm_campaign);
};

export const sendGASourceEvent = (ga = "", lineId = "anonymous") => {
  ReactGA.set({
    userId: undefined,
    referrer: `https://linebot/shop/${shopId}/user/${lineId}`,
    title: ga,
  });
  const event = {
    category: `campaign/${shopId}`,
    action: `view/${localStorage.getItem(GA_UTM_SOURCE) || "direct"}`,
    label: `shop/${shopId}/customer/${lineId}/campaign/${localStorage.getItem(
      GA_UTM_CAMPAIGN
    )}/source/${localStorage.getItem(
      GA_UTM_MEDIUM
    )}/medium/${localStorage.getItem(
      GA_UTM_CAMPAIGN
    )}/ip/${localStorage.getItem(GA_IP)}/uuid/${localStorage.getItem(GA_UUID)}`,
    value: 1,
  };
  ReactGA.event(event);
};
